import { AccommodationDetails } from '@/app/pages/accommodation-details/accommodation-details';
import { NotFoundAccommodationDetails } from '@/app/pages/errors/not-found-accommodation-details';
import { createFileRoute } from '@tanstack/react-router';

import { useGetAccommodationById } from '@/features/accommodation/hooks/use-get-accommodation-by-id';
import { accommodationDetailsSearchSchema } from '@/features/accommodation-details/config/accommodation-details-search-schema';

export const Route = createFileRoute('/accommodation-details/')({
  component: AccommodationDetails,
  validateSearch: accommodationDetailsSearchSchema,
  errorComponent: NotFoundAccommodationDetails,
  loaderDeps: ({ search }) => ({ ...search }),
  loader: async ({
    context: { queryClient, accommodationRepository },
    deps: { accommodationId, propertyType, apartmentId },
  }) =>
    await queryClient.ensureQueryData(
      useGetAccommodationById.options({
        propertyId: accommodationId,
        roomTypeId: apartmentId || undefined,
        propertyType,
        repository: accommodationRepository,
      }),
    ),
});
